import { Grid } from "@mui/material";
import { ArticleCard } from "@thrivetribe/mvf.ui.molecules.article-card";
import { GenericCard } from "@thrivetribe/mvf.ui.molecules.generic-card";
import React from "react";
import { Link } from "react-router-dom";
import { ArticleType } from "types";
import "./ThreeCards.scss";

interface ThreeCardsProps {
  title: string;
  description: string;
  articles: ArticleType[];
}

export const ThreeCards: React.FC<ThreeCardsProps> = ({ title, description, articles }: ThreeCardsProps) => {
  return (
    <Grid container rowSpacing={2} columnSpacing={{ sm: 1, md: 2 }} className="three-cards">
      <Grid item sm={12} md={12} lg={4}>
        <GenericCard title={title} description={description} />
      </Grid>
      {articles?.map((x) => (
        <Grid item sm={12} md={6} lg={4} key={x.id}>
          <Link to={`/articles/${x.slug}`}>
            <ArticleCard
              title={x.title}
              description={x.introduction}
              imgUrl={x.asset.file.url}
              imgTitle={x.asset.description}
              onClick={() => {
                window.scroll(0, 0);
              }}
            />
          </Link>
        </Grid>
      ))}
    </Grid>
  );
};
